import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';
import { ALL_USER_ROLES } from '../../../constants/roles/userRoleTypes';

const useSelfDesignationOtpRole = () => {
    let role = ALL_USER_ROLES.BROKER.toLowerCase();

    const userRole = useAppSelector(environmentSelector).user.role || '';
    if (userRole === ALL_USER_ROLES.ASSISTER) {
        role = ALL_USER_ROLES.ASSISTER.toLowerCase();
    }

    return { role };
};

export default useSelfDesignationOtpRole;
